import React from 'react'
import PropTypes from 'prop-types'
import clsx from 'clsx'
import { createUseStyles } from 'react-jss'

const defaultBaseColor = '#eeeeee' // gray-4
const defaultHighlightColor = '#f7f7f7' // gray-5

const styles = {
	'@keyframes skeletonAnimation': {
		'0%': { backgroundPosition: '-200px 0' },
		'100%': { backgroundPosition: 'calc(200px + 100%) 0' }
	},
	skeletonStyles: {
		backgroundColor: props => props.baseColor || defaultBaseColor,
		backgroundImage: props => `linear-gradient(90deg, ${props.baseColor || defaultBaseColor}, ${props.highlightColor || defaultHighlightColor
			}, ${props.baseColor || defaultBaseColor})`,
		backgroundSize: '200px 100%',
		backgroundRepeat: 'no-repeat',
		display: 'inline-block',
		lineHeight: 1,
		width: props => props.width ? (typeof props.width === 'string' ? props.width : `${props.width}px`) : '100%',
		height: props => props.height && (typeof props.height === 'string' ? props.height : `${props.height}px`),
		borderRadius: props => (props.width && props.width && props.circle && '50%') || '4px',
		animationName: '$skeletonAnimation',
		animationDuration: props => `${props.duration}ms`,
		animationIterationCount: 'infinite',
		animationTimingFunction: 'ease-in-out',
		'-webkit-animation-name': '$skeletonAnimation',
		'-webkit-animation-duration': props => `${props.duration}ms`,
		'-webkit-animation-iteration-count': 'infinte',
		'-webkit-animation-timing-function': 'ease-in-out',
		'-moz-animation-name': '$skeletonAnimation',
		'-moz-animation-duration': props => `${props.duration}ms`,
		'-moz-animation-iteration-count': 'infinte',
		'-moz-animation-timing-function': 'ease-in-out',
		'-o-animation-name': '$skeletonAnimation',
		'-o-animation-duration': props => `${props.duration}ms`,
		'-o-animation-iteration-count': 'infinte',
		'-o-animation-timing-function': 'ease-in-out'
	}
}

const useStyles = createUseStyles(styles, { name: 'Vb' })

const Skeleton = (props) => {
	const {
		count,
		baseColor,
		duration,
		width,
		wrapper: Wrapper,
		height,
		highlightColor,
		circle,
		className,
		...other
	} = props

	const classes = useStyles(props)

	const elements = []
	for (let i = 0; i < count; i++) {
		elements.push(
			<span key={i} className={clsx(className, classes.styles, classes.skeletonStyles)} {...other}>
				&zwnj;
			</span>
		)
	}

	return (
		<>
			{Wrapper
				? elements.map((element, i) => (
					<Wrapper key={i}>
						{element}
						&zwnj;
					</Wrapper>
				))
				: elements}
		</>
	)
}

export default Skeleton

Skeleton.defaultProps = {
	baseColor: '#EEEEEE',
	count: 1,
	circle: false,
	duration: 1200,
	height: '100%',
	highlightColor: '#F7F7F7',
	width: '100%',
}

Skeleton.propTypes = {
	/**
	 * Number of horizontal sections,
	 * simulating paragraph lines
	 */
	count: PropTypes.number,
	/**
	 * Color value of the skeleton color
	 * @default '#EEEEEE'
	 */
	baseColor: PropTypes.string,
	/**
	 * Duration of the shimmer animation, in miliseconds
	 * @default 1200
	 */
	duration: PropTypes.number,
	/**
	 * With of the skeleton
	 * @default '100%'
	 */
	width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
	/**
	 * Wrapper component to encapsule the skeleton span
	 */
	wrapper: PropTypes.element,
	/**
	 * With of the skeleton
	 * @default '100%'
	 */
	height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
	/**
	 * Color value of the skeleton shimmer (wave) animation
	 * @default '#F7F7F7'
	 */
	highlightColor: PropTypes.string,
	/**
	 * If true when with and height are setted,
	 * skeleton will be a round circle
	 */
	circle: PropTypes.bool
}
